import { useCallback } from "react";

export const useInitialDocument = () => {
    const fetchDocumnets = useCallback(async (documents) => {
        const promises = [];

        documents.forEach((el) => {
            promises.push(
                fetch(el.document_url).then((response) =>
                    response.blob().then((data) => 
                        new File([data], el.file_name, {
                            type: data.type
                        })
                    ),
                ),
            );
        });

        return await Promise.all(promises);
    }, []);
    return { fetchDocumnets };
};
